module.exports = __webpack_public_path__ + "media/images/icons/favicon-96x96-06bc2b7f40f26632128ec6ec057d5885.png";